<script type="text/javascript">
	import { onMount } from "svelte";
	import { get } from "svelte/store";
	import Analytics from "../Analytics/Analytics";
	import AuthStore from "../Auth/Store";
	import Feature from "../Branding/Feature";
	import User from "../Branding/User";
	import LoadState from "../Enums/LoadState";
	import GeoHelper from "../Helpers/GeoHelper";
	import LoadingStore from "../LoadingStore";
	import MapDataSource from "../Map/Enums/MapDataSource";
	import MapLayer from "../Map/Enums/MapLayer";
	import MapLayerManager from "../Map/MapLayerManager";
	import PopupStore from "../Map/Popup/PopupStore";
	import MapStore from "../Map/Store";
	import ModalWindow from "../UI/ModalWindow.svelte";
	import SanctionStore from "./Store";
		
	let loadState = SanctionStore.meta.loadState;
	let countryResults = SanctionStore.results.byCC;
	let sanctions = SanctionStore.results.current;
	let visible = MapStore.sanctionsVisible;
	$: {
		if ($loadState === LoadState.LOADED && $visible) {
			const map = get(MapStore.mapbox.instance);
			map.getSource(MapDataSource.SANCTIONS_POLYGONS).setData(GeoHelper.emptyGeoJson($countryResults));

			MapLayerManager.updateVisibleLayers();
		}
	}
	$: {
		$sanctions;
	}

	
	$: {
		if ($visible) {
			SanctionStore.actions.initMap(MapStore.helpers.getMap());
		} 
		else {
			SanctionStore.actions.deinitMap();
		}
	}

	let open = false;
	onMount(() => {
		
		MapStore.sanctionsVisible.subscribe((visible) => {
			if (visible && User.hasFeature(Feature.SANCTIONS.VIEW)) {
				SanctionStore.actions.init();

				const map = get(MapStore.mapbox.instance);
				const mapInitialised = get(MapStore.meta.initialised);

				if (map && mapInitialised) {
					let onSanctionLayerClick = (e) => {
						e.preventDefault();

						if (!open) {
							const clickedFeature = e.features[0];
							//console.log("clickedFeature", clickedFeature);
							// const group = SanctionStore.helpers.findByLngLat(clickedFeature.properties.lng, clickedFeature.properties.lat);
							const group = SanctionStore.helpers.findByCC(clickedFeature.properties.cc);
							if (!group) {
								console.warning("could not find sanction group");
								return;
							}

							// For some reason this is encoded?
							const clickedForSanctions = group.properties.sanctions;
							clickedForSanctions.sort((one,two) => { // Sort by newest at the top.
								return two.date - one.date;
							});
							$sanctions = clickedForSanctions;
							// console.log("Opened sanctions", $sanctions);
							Analytics.event("open_countrycode_" + clickedFeature.properties.cc, { category: "Sanctions", username: get(AuthStore.userInfo).username, cc: clickedFeature.properties.cc });
							open = true;
						}
						// TODO: make the modal window content div scroll back to the top

					};
					let onSanctionLayerEnter = (e) => {
				  		map.getCanvas().style.cursor = 'pointer';
				  		if (e.features.length > 0) {
					 		const group = SanctionStore.helpers.findByCC(e.features[0].properties.cc);
							if (group) {
								const sanctions = group.properties.sanctions;
								const coords = [e.lngLat.lng, e.lngLat.lat]; // GeoHelper.calcCenter(e.features[0]);

								let html = "";
								html += `<strong>Sanctions - ${e.features[0].properties.name}</strong><br/>`;
								html += "<table>";
								let counts = {};
								for (let i = 0; i < sanctions.length; i++) {
									const a = sanctions[i].authority;
									if (typeof counts[a] === "undefined") {
										counts[a] = 1;
										continue;
									}
									counts[a]++;
								}
								for (let i = 0; i < Object.keys(counts).length; i++) {
									let key = Object.keys(counts)[i];
									html += `<tr>
												<td><strong>${key}</strong>:</td>
												<td>${counts[key]}</td>
											 </tr>`;
								}
								html += "</table>";
								html += "<i>Click to view</i>";

								PopupStore.actions.customHtml(html, 400, coords, true);
							}
						}
					};
					let onSanctionLayerLeave = (e) => {
				  		map.getCanvas().style.cursor = MapStore.helpers.getDefaultCursor();
				  		PopupStore.actions.custom({}, null, false);
					};

					map.on("click", MapLayer.SANCTIONS_POLYGONS, onSanctionLayerClick);
					map.on("mouseenter", MapLayer.SANCTIONS_POLYGONS, onSanctionLayerEnter);
					map.on("mousemove", MapLayer.SANCTIONS_POLYGONS, onSanctionLayerEnter);
					map.on("mouseleave", MapLayer.SANCTIONS_POLYGONS, onSanctionLayerLeave);
				}
			}
		});
		return LoadingStore.onMount("sanctions", loadState);
	});

</script>

<ModalWindow materialIcon={"warning"} title={`Sanctions (${$sanctions.length})`} hasCloseButton={true} bind:open={open}>
	{#each $sanctions as sanction, index}
		<div style="border-bottom:1px solid #ddd">
			<h2><b>{sanction.readableAuthority}</b> - {sanction.country} {(sanction.country.length>0)?" - ":""} <i>{sanction.readableDate}</i> : <a href={sanction.url} target="new">{@html sanction.title}</a></h2>
			{#if sanction.description !== "N/A"}
				<p>{@html sanction.description}</p>
			{/if}
		</div>
	{/each}
</ModalWindow>
